import React from 'react';
import { HeroSection } from './components/HeroSection';
import { HookSection } from './components/HookSection';
import { ProblemSection } from './components/ProblemSection';
import { FailedSolutions } from './components/FailedSolutions';
import { MechanismSection } from './components/MechanismSection';
import { WhatYouGet } from './components/WhatYouGet';
import { AudienceSection } from './components/AudienceSection';
import { HowItWorks } from './components/HowItWorks';
import { ProofSection } from './components/ProofSection';
import { FAQSection } from './components/FAQSection';
import { OfferSection } from './components/OfferSection';
import { FooterSection } from './components/FooterSection';
export function App() {
  return <div className="min-h-screen bg-[#0a0e1a] text-[#b8c4d6] font-sans overflow-x-hidden" data-id="element-0">
      <HeroSection data-id="element-1" />
      <HookSection data-id="element-2" />
      <ProblemSection data-id="element-3" />
      <FailedSolutions data-id="element-4" />
      <MechanismSection data-id="element-5" />
      <WhatYouGet data-id="element-6" />
      <AudienceSection data-id="element-7" />
      <HowItWorks data-id="element-8" />
      <ProofSection data-id="element-9" />
      <FAQSection data-id="element-10" />
      <OfferSection data-id="element-11" />
      <FooterSection data-id="element-12" />
    </div>;
}